export default __webpack_public_path__ + "static/media/bislig-front.767d97fe.png";